// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx actions
import { setCustomPDFReportBuilderStore } from '../custom-pdf-report-builder/custom-pdf-report-builder.action';
import { setReportFooter } from './report-footer.actions';
export const report_footer = createReducer(null, on(setCustomPDFReportBuilderStore, setReportFooter, (state, action) => {
    return action.report_footer;
}));
